import React from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux"
import { BUS_CHASSIS_PATH } from "../../../../config/paths";
import { postBusChassis } from '../../../../actions';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from "../../../layout/Content";
import BusChassisForm from "./BusChassisForm";

export const NewBusChassis = ({ breadcrumbs, dispatchPostBusChassis }) => {
  const onSubmit = (formValues) => {
    const newFormValues = { ...formValues };

    dispatchPostBusChassis(newFormValues);
  };

  const content = (
    <BusChassisForm
      onSubmit={onSubmit}
      initialValues={{}}
    />
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Chasís"
      subtitle="Crear nuevo chasís"
      content={content}
    />
  );
};

NewBusChassis.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostBusChassis: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostBusChassis: postBusChassis,
};

const mapStateToProps = ({ BusUnit }) => ({
  breadcrumbs: [
    ...BusUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Chasís',
      href: BUS_CHASSIS_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(mapStateToProps, mapDispatchToProps)(NewBusChassis)